<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-card :elevation="hover ? 12 : 2"
              class="mx-auto"
              max-height="250"
              max-width="380" @click="calendarInfo = true">
        <div class="d-flex">
          <div class="pa-3">
            <div class="text-h5" style="color:rgb(216 48 48)">
              {{ weekList[$moment(today).weekday()] }}
            </div>
            <div class="text-h1 text-center day-class">
              {{ $moment(today).date() }}
            </div>

            <div class="text-subtitle text-center text-length">
              <div class="text-class">
                {{ today }}
              </div>
              <div class="text-class">
                {{ parseDateToLunarStr(today) }}
              </div>
            </div>
          </div>
          <div class="ml-auto">
            <v-date-picker v-model="today" no-title width="250" disabled
                           :header-date-format="headerDateFormat"
                           :weekday-format="pickerWeekdayFormat">
            </v-date-picker>
          </div>
        </div>
      </v-card>
    </v-hover>


    <v-dialog v-if="calendarInfo" v-model="calendarInfo"  fullscreen hide-overlay>
      <v-card class="mx-auto">

        <v-toolbar dense flat>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                icon
                @click="calendarInfo = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-title>
          <div class="d-inline mr-5">
            <v-sheet
                class="text-center pa-2"
                rounded="xl"
                elevation="3"
                height="100"
                width="100"
            >
              <div>
            <span class="text-h3">
              {{ $moment(value).date() }}
            </span>
              </div>
              <div>
            <span class="text-h6" style="color:rgb(216 48 48)">
              {{ weekList[$moment(value).weekday()] }}
            </span>
              </div>
            </v-sheet>
            <div class="text-center pa-3">
              <div class="text-subtitle-1" v-if="dayInfo">{{ dayInfo.gzYear }}年 {{
                  dayInfo.animal
                }}
              </div>
            </div>
          </div>
          <div class="d-inline" style="max-width: 500px;">
            <div class="text-body-1">
              <div class="pa-1">
                <div v-if="this.dayInfo">
                  {{ value }}
                </div>
              </div>
              <div class="pa-1  avoid-class">
                <div class="">
                  <v-avatar
                      color="primary"
                      rounded
                      size="24"
                  >宜
                  </v-avatar>
                </div>
                <div class="pa-2 text-no-wrap text-truncate" v-if="dayInfo.avoid">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs"
                          v-on="on">
                      {{ dayInfo.avoid ? dayInfo.avoid.split('.').slice(0, 9).join() : '' }}
                    </span>
                    </template>
                    <span>{{ dayInfo.avoid ? dayInfo.avoid.split('.').join() : '' }}</span>
                  </v-tooltip>
                </div>
              </div>

              <div class="pa-1  avoid-class">
                <div>
                  <v-avatar
                      color="red"
                      rounded
                      size="25"
                  >忌
                  </v-avatar>
                </div>
                <div class="pa-2 text-no-wrap text-truncate" v-if="dayInfo.suit">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs"
                          v-on="on">
                      {{ dayInfo.suit ? dayInfo.suit.split('.').slice(0, 9).join() : '' }}
                    </span>
                    </template>
                    <span>{{ dayInfo.suit ? dayInfo.suit.split('.').join() : '' }}</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
          </div>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-sheet tile
                   height="54"
                   class="d-flex">
            <v-btn
                icon
                class="ma-2"
                @click="$refs.calendar.prev()"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-btn class="ma-2" plain @click="dialog = true">{{ $moment(value).year() }}</v-btn>

            <v-btn class="ma-2" plain @click="dialog = true">{{ $moment(value).month() + 1 }}</v-btn>

            <v-btn
                icon
                class="ma-2"
                @click="$refs.calendar.next()"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>

            <v-btn class="ma-2" plain v-if="showToday"
                   @click="getToday">
              今天
            </v-btn>

          </v-sheet>
          <v-calendar
              ref="calendar"
              v-model="value"
              type="month"
              :show-month-on-first="false"
              :weekday-format="calendarWeekdayFormat"
              :events="events"
              @change="getEvents"
          >
            <template v-slot:day="{date}">
              <v-container
                  :class="{'day-container':events.filter(e=>$moment(date).isBetween(e.start, e.end, undefined, '[]')).length !== 0}">
                <v-row justify="center">
                  <div class="text-center">
                    <div v-if="showLunar === $moment(date).month()">
                      <v-subheader>{{ dayFormat(date) }}</v-subheader>
                    </div>
                  </div>
                </v-row>
              </v-container>
            </template>
          </v-calendar>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog
        v-model="dialog"
        max-width="290"
    >
      <v-card
          v-show="dialog"
          class="mx-auto secondary"
      >
        <v-date-picker v-model="value" :title-date-format="titleDateFormat"
                       :month-format="monthFormat"
                       :header-date-format="headerDateFormat" :weekday-format="pickerWeekdayFormat"></v-date-picker>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {getLunar} from 'chinese-lunar-calendar'
import {getHoliday, openData} from '@/api/jsonp/calendar'

export default {
  name: "calendar",
  data: () => ({
    calendarInfo: false,
    today: undefined,
    events: [],
    value: undefined,
    dialog: false,
    // picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    monthList: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    weekList: ['周天', '周一', '周二', '周三', '周四', '周五', '周六'],
    almanac: [],
  }),
  computed: {
    showLunar() {
      if (this.value) {
        return this.$moment(this.value).month()
      } else {
        return this.$moment().month()
      }
    },
    showToday() {
      return this.$moment(this.value).format('YYYY-MM-DD') !== this.today
    },
    dayInfo() {
      if (this.value) {
        let _date = this.$moment(this.value)
        return this.almanac.find(item => item.day == _date.date() && item.month == _date.month() + 1)
      }
      return undefined
    }
  },
  mounted() {
    this.initDate()
    window.callBackMsCalendar = (data) => {
      this.almanac = data.data[0].almanac
    }
  },
  methods: {
    getToday() {
      let today = this.$moment().format('YYYY-MM-DD')
      this.value = today
      this.today = today
    },
    initDate() {
      this.getToday();
      this.getCalendar();
    },

    getEvents({start}) {
      let {month, year} = start
      this.getCalendar()
      getHoliday({
        year: `${year}`
      }).then((req) => {
        this.events = []
        let _offList = []
        let _onList = []
        let {dayOff, dayOn} = req.data.data

        let _off = dayOff[month]
        if (_off) {
          for (let i = 0; i < _off.length; i++) {
            _offList.push({
              name: '节假日休息✈️',
              start: _off[i][0].date,
              end: _off[i][_off[i].length - 1].date,
              color: "red",
              timed: true,
            })
          }
        }
        let _on = dayOn[month]
        if (_on) {
          for (let i = 0; i < _on.length; i++) {
            _onList.push({
              name: '节假日调休👨‍💻',
              start: _on[i][0].date,
              end: _on[i][_on[i].length - 1].date,
              color: "blue",
              timed: true,
            })
          }
        }
        this.events = [..._onList, ..._offList]
      })
    },
    calendarWeekdayFormat(m) {
      return this.weekList[m.weekday]
    },
    dayFormat(time) {
      if (!this.almanac.length) return

      let day = this.$moment(time)

      let item = this.almanac.find(item => item.year == day.year() && item.month == day.month() + 1 && item.day == day.date())

      if (item && item.term) {
        return item.term
      } else {
        let {dateStr} = getLunar(day.year(), day.month() + 1, day.date())

        if (dateStr.indexOf('初一') === -1) {
          return dateStr.substring(2)
        } else {
          return dateStr.substring(0, 2);
        }
      }

    },
    titleDateFormat(time) {
      let date = this.$moment(time)
      return `${date.month() + 1}月, ${date.date()}`
    },
    headerDateFormat(time) {
      let _data = time.split('-')
      if (_data.length === 1) {
        return _data[0]
      } else {
        return `${this.monthList[_data[1] - 1]}  ${_data[0]}`
      }
    },
    pickerWeekdayFormat(time) {
      let date = this.$moment(time)
      return this.weekList[date.weekday()]
    },
    monthFormat(time) {
      let date = this.$moment(time)
      return this.monthList[date.month()]
    },
    getCalendar() {
      let _day = this.$moment(this.value)
      let msCalendarParams = {
        'resource_id': 39043,
        'format': 'json',
        't': new Date().getTime(),
        'query': `${_day.year()}年${_day.month() + 1}月`,
        'ie': 'utf8',
        'oe': 'utf8',
        'tn': 'wisetpl',
        output: 'jsonp',
        cb: 'callBackMsCalendar'
      }
      openData(msCalendarParams).then()
    },
    parseDateToLunarStr(date) {
      let _date = this.$moment(date)
      return getLunar(_date.year(), _date.month() + 1, _date.date()).dateStr
    }
  },

}
</script>

<style scoped>
/deep/ .v-date-picker-header--disabled {
  display: none;
}

.text-length {
  min-width: 83px;
}

.day-class {
  line-height: 120px;
}

.text-class {
  font-size: 16px;
  line-height: 30px;
}

.avoid-class {
  display: flex;
  align-items: center;
  line-height: 25px;
  max-width: 300px;
}

</style>
<style lang="scss">
.day-container {
  margin-top: 10px;
}
</style>
